import * as React from 'react';

import { BaseComponent } from '@fluentui/react';
import {Icon} from '@fluentui/react';
import { TagPicker, ITag } from '@fluentui/react';
import Api from '../../../services/Api'

const warningIcon = <div className='warning-inline warning-nolabel-basepicker' title="Field cannot be empty"><Icon  iconName="Warning"/></div>

export interface ITagPickerDemoPageState {
    isPickerDisabled?: boolean;
}

export class ItemPicker extends BaseComponent<{}, ITagPickerDemoPageState> {

    constructor(props: {}) {
        super(props);
        this.state = {
            isPickerDisabled: false,
            isChanged : false,
            stopReloading : false
        };
        this.possibilities = [];
    }

    componentDidMount() {
        if(this.props.defaultValue && !this.state.isChanged)
        {
            this.props.itemSelector(this.props.defaultValue);
        }
    }


    render() {
        
        const isParent = this.props.selection != null && this.props.selection.hasOwnProperty('isParent') ? true : false;

        const currentSelection =  this.props.selection  || !this.state.isChanged ?
             (!this.state.isChanged && this.props.defaultValue && !isParent ? [{key: this.props.defaultValue.key, name : this._getValueFromItem(this.props.defaultValue)}] :
             this.props.selection ? [{key: this.props.selection.key, name : this._getValueFromItem(this.props.selection)}] : null) : [];//;
        
        const warning = this.props.isRequired && (currentSelection == null || currentSelection.length === 0) ? warningIcon : null;
        
        return (
            <div style={{flex: 1, position: 'relative', maxWidth: '100%'}}>
               <div style={{fontSize:'14px',marginBottom:'6px', fontWeight:'normal'}}>{this.props.searchTitle} </div>
                {warning}
                <TagPicker
                    onResolveSuggestions={this.getItemsFromSearch}
                    getTextFromItem={this._getTextFromItem}
                    onItemSelected = {this._onItemSelected}
                    onChange = {this.onChangeSelection}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: 'Items to pick',
                        noResultsFoundText: 'No results found'
                    }}
                    selectedItems = {currentSelection}
                    itemLimit={1}
                    disabled={this.props.isPickerDisabled}
                    resolveDelay={300}
                    styles={{input: {marginRight: '20px'}}}
                    
                />
            </div>
        );
    }

    getItemsFromSearch = (searchText, items) => {
        if(!searchText)
            return items;
        // console.log("getItemsFromSearch");
        // return { key: 'TestKey2', name: 'TestName2'};

        const url = this.props.url + searchText;
        return new Promise((resolve) => {
            this.getItems(url, (err, results) => {
                if (!err) {
                    let options = results.map(item => ({
                            key: item.key,
                            name: this._getValueFromItem(item)
                        })
                    );
                    resolve(options);
                }
            });
        });
    }

    getItems(url, callback)
    {
        Api.get(url)
            .then(res => res.data)
            .then(items =>
                {
                    if (this.props.additionalOptions) {
                        items = [...this.props.additionalOptions, ...items];
                    }

                    this.possibilities = items;
                    callback(null, items);
                }
            ).catch((error) => {
                callback(error,null)
            });
    }

    onChangeSelection = (items?: T[]) => {
        this.setState({isChanged: true})
        if(items.length === 0)
        {
            this.props.itemSelector(null);
        }
    };

    _getValueFromItem(item) {
        return item.key !== item.value && item.key !== 'Cross' ? `${item.key} - ${item.value}` : item.value;
    }

    _getTextFromItem(item: ITag): string {
        return item.name;
    }

     _onFilterChanged = (filterText: string, tagList: ITag[]): ITag[] => {
        this.getItemsFromSearch(filterText);
        //console.log(this.possibilities)
        return filterText
            ? this.possibilities
                .filter(tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0)
            : [];
    };

    _onItemSelected = (item: ITag): ITag | null => {
        // var selection = {key: item.key, value : item.name}
        var chosenItem = this.possibilities.filter(p => p.key === item.key)[0];
        this.props.itemSelector(chosenItem);
        return item;
    };

    //  _onFilterChangedNoFilter = (filterText: string, tagList: ITag[]): ITag[] => {
    //     return filterText ? this.state.possibilities.filter(tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0) : [];
    // };



    //  _listContainsDocument(tag: ITag, tagList?: ITag[]) {
    //     if (!tagList || !tagList.length || tagList.length === 0) {
    //         return false;
    //     }
    //     return tagList.filter(compareTag => compareTag.key === tag.key).length > 0;
    // }
}


// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/ItemPicker.js